const buttonTouchStyles = () => {
  const buttons = document.querySelectorAll('.c-button');
  const className = 'c-button--touched';
  const handleClassToggle = (e) => e.target.classList.toggle(className);

  buttons.forEach((button) => button.addEventListener('touchstart', handleClassToggle));
  buttons.forEach((button) => button.addEventListener('touchend', handleClassToggle));
};

export default buttonTouchStyles;
